import { Compass } from "@phosphor-icons/react";
import { Link } from "react-router";

import { useT } from "../i18n";
import { EmptyState } from "../ui/states";

export default function NotFoundPage() {
  const t = useT().auth.notFound;
  return (
    <EmptyState icon={<Compass weight="duotone" />} title={t.title}>
      {t.body(<Link to="/">{t.backHome}</Link>)}
    </EmptyState>
  );
}
